import KpiDefinitionForm from './KpiDefinitionForm';

export default function CreateKpiDefinitionPage() {
  return <KpiDefinitionForm />;
}
